module.exports = __webpack_public_path__ + "static/img/main6_3.9ead638b.png";